/* eslint-disable no-undef */
import axios from "axios";
import Cookies from "js-cookie";

type Headers = {
    "X-Parse-Application-Id": string;
    "X-Parse-REST-API-Key": string;
    "X-Parse-Session-Token"?: string;
}

const axiosclient = () => {
    const localToken = Cookies.get(process.env.GATSBY_SESSION_TOKEN as string);
    const token = localToken || "";

    const headers: Headers = {
        "X-Parse-Application-Id": process.env.GATSBY_PATSTORE_APP_ID as string,
        "X-Parse-REST-API-Key": process.env.GATSBY_PATSTORE_REST_KEY as string
    }

    if (token) {
        headers["X-Parse-Session-Token"] = token;
    }

    return axios.create({
        baseURL: process.env.GATSBY_PATSTORE_API_URL,
        headers
    });
};

export default axiosclient;
